module.exports = __webpack_public_path__ + "static/media/inktoberBat.f9cf5da4.gif";